<template>
    <div class="container">
        <el-menu class="el-menu-vertical-demo" :collapse="isCollapse" text-color="#FFFFFF" active-text-color="#FFFFFF"
            :unique-opened="true" router :default-active="$route.path">
            <div class="line"></div>
            <!-- <el-menu-item index="/home">
                <i class="el-icon-pie-chart"></i>
                <span slot="title">告警概览</span>
            </el-menu-item> -->
            <el-menu-item index="/alarm/list">
                <i class="el-icon-stopwatch"></i>
                <span slot="title">告警列表</span>
            </el-menu-item>
            <el-menu-item index="/target/list">
                <i class="el-icon-aim"></i>
                <span slot="title">目标列表</span>
            </el-menu-item>
            <el-menu-item index="/member/list">
                <i class="el-icon-user"></i>
                <span slot="title">成员管理</span>
            </el-menu-item>
            <el-menu-item index="/admin/list">
                <i class="el-icon-setting"></i>
                <span slot="title">管理员管理</span>
            </el-menu-item>
        </el-menu>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            isCollapse: false
        }
    },
    watch: {},
    computed: {},
    mounted() {},
    methods: {}
}
</script>
<style lang="scss" scoped>
.container {
    .el-menu {
        border: none;
    }
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
        height: auto;
    }
    .el-menu {
        background-color: #fff;
        &.el-menu-vertical-demo {
            background-color: #fff;
            border-right: none;
            .line {
                width: 200px;
                height: 20px;
                background-color: #283244;
            }
        }
        .el-menu-item {
            height: 50px;
            line-height: 50px;
            background-color: #283244;
            &:hover {
                background-color: rgba(0, 0, 0, 0.9);
                &::after {
                    display: block;
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    bottom: 0;
                    width: 4px;
                    background-color: #14cfab;
                    z-index: 1;
                }
            }
            img {
                width: 20px;
                height: 20px;
                margin-bottom: 10px;
                display: none;
                &.normal {
                    display: inline-block;
                }
            }
            span {
                height: 20px;
                line-height: 20px;
                display: inline-block;
                color: #fff;
            }
            &.is-active {
                background-color: #1a212e;
                position: relative;
                span {
                    color: #fff;
                }
                img {
                    &.normal {
                        display: none;
                    }
                    &.active {
                        display: inline-block;
                    }
                }
                &::after {
                    display: block;
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    bottom: 0;
                    width: 4px;
                    background-color: #14cfab;
                    z-index: 1;
                }
            }
        }
    }
}
</style>